import { render } from "./label-pc.vue?vue&type=template&id=af08fb32&ts=true"
import script from "./label-pc.vue?vue&type=script&lang=ts"
export * from "./label-pc.vue?vue&type=script&lang=ts"

import "./label-pc.vue?vue&type=style&index=0&id=af08fb32&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__